import React from "react";
import { Message } from "../../../store/chat-messages/types";
import styles from "./ChatMessage.module.css";

interface ChatMessageProps {
  message: Message;
  isMobile?: boolean;
  isLastMessage?: boolean;
}
export const ChatMessage: React.FC<ChatMessageProps> = ({ message, isMobile = false, isLastMessage= false }) => {
  return (
    <div className={`${isLastMessage ? styles["last-message"] : ""}`}>
      <dl className={`${styles["script"]}`}>
        <dt
          className={`${message.sender === "me" ? styles["local-color"] : isMobile ? styles["mobile-color"] : ""}`}
        >
          {" "}
          {message.sender}{" "}
        </dt>
        <dd className={`${isMobile ? styles["mobile-color"] : ""}`}> {message.message} </dd>
      </dl>
    </div>
  );
};
